import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'جاري التحميل...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-wrapper">
        <div className="spinner-ring">
          <div className="spinner-ring-inner"></div>
        </div>
        <div className="spinner-dots">
          <span className="dot dot-1"></span>
          <span className="dot dot-2"></span>
          <span className="dot dot-3"></span>
        </div>
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;



